import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import AddressProp from '../../../../commonComponents/propTypes/addressProp';
import PinIcon from '../../../../commonComponents/icons/PinIcon';
import { displayUserName } from '../../../../services/utilityFunctions';

function AddressSection(props) {
  const { address, title } = props;

  if (!address) {
    return null;
  }

  const {
    firstName,
    lastName,
    address_1,
    address_2,
    zipCode,
    state,
    country,
    phone,
    email,
    NIF,
    companyName,
  } = address;

  const addressUserName = !companyName
    ? displayUserName({ firstName, lastName })
    : companyName || '';
  return (
    <div className="address-container">
      {title ? (
        <div className="title-container">
          <PinIcon />
          <p className="title">{title}</p>
        </div>
      ) : null}
      {addressUserName?.length > 0 ? (
        <p className="field">{addressUserName}</p>
      ) : null}
      {address_1 ? <p className="field">{address_1}</p> : null}
      {address_2 ? <p className="field">{address_2}</p> : null}
      {zipCode ? <p className="field">{zipCode}</p> : null}
      {state ? <p className="field">{state}</p> : null}
      {country ? <p className="field">{country}</p> : null}
      {phone ? <p className="field">{phone}</p> : null}
      {email ? <p className="field">{email}</p> : null}
      {NIF ? <p className="field">{NIF}</p> : null}
    </div>
  );
}

AddressSection.propTypes = {
  title: PropTypes.string,
  address: PropTypes.shape(AddressProp.propType),
};

AddressSection.defaultProps = {
  title: '',
  address: null,
};

export default translate(AddressSection);
